import { render, staticRenderFns } from "./GoImage.vue?vue&type=template&id=d67eb836&scoped=true"
import script from "./GoImage.vue?vue&type=script&lang=js"
export * from "./GoImage.vue?vue&type=script&lang=js"
import style0 from "./GoImage.vue?vue&type=style&index=0&id=d67eb836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67eb836",
  null
  
)

export default component.exports